import React, { useState, useEffect } from 'react';

const Preloader = () => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Use a timer to hide the preloader after a delay
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  // If not visible, don't render anything
  if (!isVisible) {
    return null;
  }

  return (
    <div id="preloader">
      <div className="skeleton-loader">
        <div className="skeleton-square"></div>
        <div className="skeleton-lines">
          <div className="skeleton-line-1"></div>
          <div className="skeleton-line-2"></div>
          <div className="skeleton-line-3"></div>
        </div>
      </div>
    </div>
  );
};

export default Preloader; 